export const tag = 'm050c055footerpwtoyota';
export const load = async () => {
    const { M050C055FooterPwToyotaComponent } = await import('./m050-c055-footer-pw-toyota.component');
    return {
        component: M050C055FooterPwToyotaComponent,
    };
};
